import React from "react";

interface Props {
  slug: string;
  isEditing: boolean;
  onToggleEdit: () => void;
}

const ProfileHeader: React.FC<Props> = ({ slug, isEditing, onToggleEdit }) => {
  return (
    <div
      className="px-6 py-5 border-b border-blue-50
                 flex items-center justify-between gap-4"
    >
      <div>
        <h1 className="text-xl font-bold text-blue-950 m-0 tracking-tight">
          Mon Profile
        </h1>

        <p className="text-xs text-slate-400 mt-1">
          url.com/{slug || "me"}
        </p>
      </div>

      <button
        onClick={onToggleEdit}
        className={`px-4 py-2 rounded-xl text-xs font-semibold border cursor-pointer
                    transition-all duration-200 hover:-translate-y-0.5
                    ${
                      isEditing
                        ? "bg-rose-50 text-rose-500 border-rose-200 hover:bg-rose-100"
                        : "bg-blue-50 text-blue-600 border-blue-200 hover:bg-blue-100"
                    }`}
      >
        {isEditing ? "Annuler" : " "}
      </button>
    </div>
  );
};

export default ProfileHeader;